import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Pagination from "react-bootstrap/Pagination";

interface PagedListPaginationProps {
    pages: number[];
    currentPage: number;
    lastPage: number;
    onPageChange: (page: number) => void;
}

export const PagedListPagination: React.FC<PagedListPaginationProps> = ({
    pages,
    currentPage,
    lastPage,
    onPageChange
}) => {
    return (
        <Row className="justify-content-md-center justify-self-center">
            <Col md="auto">
                <Pagination>
                    <Pagination.First 
                        disabled={currentPage <= 1} 
                        onClick={() => onPageChange(1)} 
                    />
                    <Pagination.Prev 
                        disabled={currentPage <= 1} 
                        onClick={() => onPageChange(currentPage - 1)} 
                    />
                    {pages.map((page) => (
                        <React.Fragment key={page}>
                            {page < 0 && <Pagination.Ellipsis disabled />}
                            {page > 0 && (
                                <Pagination.Item 
                                    active={page === currentPage} 
                                    onClick={() => onPageChange(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            )}
                        </React.Fragment>
                    ))}
                    <Pagination.Next 
                        disabled={currentPage >= lastPage} 
                        onClick={() => onPageChange(currentPage + 1)} 
                    />
                    <Pagination.Last 
                        disabled={currentPage >= lastPage} 
                        onClick={() => onPageChange(lastPage)} 
                    />
                </Pagination>
            </Col>
        </Row>
    );
};
